import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import axios from "axios";
import CustomModal from "../components/CustomModal";
import { base_url } from "../utils/baseUrl";
import { toast } from "react-toastify";
import moment from "moment";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
    width: "25px",
    align: "center"
  },
  {
    title: "Name",
    dataIndex: "name",
    align: "center"
  },
  {
    title: "Association Name",
    dataIndex: "aname",
    align: "center"
  },
  {
    title: "Email",
    dataIndex: "email",
    align: "center"
  },
  {
    title: "Phone",
    dataIndex: "phone",
    align: "center"
  },
  {
    title: "Date",
    dataIndex: "date",
    align: "center"
  },
  {
    title: "Time",
    dataIndex: "time",
    align: "center"
  },
  {
    title: "Action",
    dataIndex: "action",
    align: "center"
  },
];

const AppointmentList = () => {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [appointmentId, setAppointmentId] = useState(null);
  const [toastMessage, setToastMessage] = useState("");
  const token = useSelector((state) => state.autht.token);

  useEffect(() => {
    fetchAppointments();
  }, []);

  const fetchAppointments = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${base_url}Allappointments`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      if (response.status === 200) {
        setAppointments(response.data);
      } else {
        console.error("Error fetching appointments: Unexpected status code", response.status);
      }
    } catch (error) {
      console.error("Error fetching appointments:", error);
    }
    setLoading(false);
  };

  const showModal = (id) => {
    setAppointmentId(id);
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
  };

  const deleteAppointment = async (id) => {
    setLoading(true);
    try {
      const response = await axios.delete(`${base_url}appointments/${id}`);
      if (response.status === 200) {
        setToastMessage("Appointment deleted successfully.");
        fetchAppointments();
      } else {
        console.error("Error deleting appointment: Unexpected status code", response.status);
      }
    } catch (error) {
      console.error("Error deleting appointment:", error);
    }
    setLoading(false);
    hideModal();
  };

  const data1 = appointments
    .filter((item) => {
      const appointmentDateTime = moment(`${item.date} ${item.time}`, "YYYY-MM-DD HH:mm");
      return appointmentDateTime.isBefore(moment());
    })
    .sort((a, b) => {
      const dateTimeA = moment(`${a.date} ${a.time}`, "YYYY-MM-DD HH:mm");
      const dateTimeB = moment(`${b.date} ${b.time}`, "YYYY-MM-DD HH:mm");
      return dateTimeA - dateTimeB; // Sort by date and time in ascending order
    })
    .map((item, index) => ({
      key: index + 1,
      name: item.name,
      aname:item.aname,
      email: item.email,
      phone: item.phone,
      date: item.date,
      time: item.time, // Assuming timeSlotID contains a time field
      action: (
        <>
          <>
         
         <button className="btn btn-danger">Expire</button>
       </>
        </>
      ),
    }));

  return (
    <div>
      <h3 className="mb-4 title">Live Event List</h3>
      <div>
        <Table columns={columns} dataSource={data1} pagination={false} loading={loading} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => deleteAppointment(appointmentId)}
        title="Are you sure you want to delete this appointment?"
      />
      {toastMessage && (
        <div className="toast">
          <p>{toastMessage}</p>
        </div>
      )}
    </div>
  );
};

export default AppointmentList;
